import { datadogRum } from '@datadog/browser-rum';

const setupRum = (
    loginUser: string,
    loginEmail: string,
    version: string,
    envName: string,
    applicationId: string,
    clientToken: string
): void => {
    if (applicationId && clientToken) {
        datadogRum.init({
            applicationId: applicationId,
            clientToken: clientToken,
            // `site` refers to the Datadog site parameter of your organization
            // see https://docs.datadoghq.com/getting_started/site/
            site: 'datadoghq.eu',
            service: 'decision-studio-management-ui',
            env: envName,
            version: version,
            sessionSampleRate: 100,
            sessionReplaySampleRate: 0,
            defaultPrivacyLevel: 'allow',
        });

        datadogRum.setUser({id: loginUser, name: loginEmail})
    }
};

export default setupRum;